export default "__VITE_ASSET__BJpDqc0C__"